import React from "react"
import PropTypes from "prop-types"
import moment from "moment"
import Grid from "./Grid"
import { getPath } from "../../lib"
import Period from "./Period"

function getEncounterClass(encounter) {
    return encounter.class && typeof encounter.class == "object" ?
        (getPath(encounter, "class.type.0.text") ?? getPath(encounter, "class.code")) :
        encounter.class;
}

function getEncounterADT(encounter) {
    let result = getPath(encounter, "meta.extension");
    console.log("Encounter meta.extension:", result);
    if (Array.isArray(result)) {
        let a03Found = false;
        let adtFound = false;
        for (let i = 0; i < result.length; i++) {
            if (result[i]?.url.includes('source-event-trigger')) {
                a03Found = true;
            }
            if (result[i]?.url.includes('source-record-type')) {
                adtFound = true;
            }
        }
        if (a03Found && adtFound) {
            return "ADT^A03";
        }
    }
    return null;
}

function getEncounterLabel(encounter) {
    let result = getPath(encounter, "type.0.text");
    if (result) {
        return result;
    }
    let _class = getEncounterClass(encounter);
    if (_class) {
        return _class + " encounter";
    }
    return "";
}

function getEncounterReason(encounter) {
    let result1 = getPath(encounter, "reason.0.coding.0.display");
    if (result1) {
        return result1;
    }
    let result2 = getPath(encounter, "reasonCode.0.coding.0.code");
    if (result2) {
        return result2;
    }
    return "N/A";
}

export default class Encounter extends React.Component {
    static propTypes = {
        resources: PropTypes.arrayOf(PropTypes.object)
    };

    render() {
        return (
            <Grid
                rows={(this.props.resources || []).map(o => o.resource)}
                title={`Encounter${this.props.resources.length === 1 ? "" : "s"}`}
                groupBy="Type"
                comparator={(a, b) => {
                    let dA = getPath(a, "period.start");
                    let dB = getPath(b, "period.start");
                    dA = dA ? +moment(dA) : 0;
                    dB = dB ? +moment(dB) : 0;
                    return dB - dA;
                }}
                cols={[
                    {
                        label: "Type",
                        path: rec => getEncounterLabel(rec),
                        render: rec => {
                            let adt = getEncounterADT(rec);
                            console.log("Encounter ADT:", adt);
                            if (adt) {
                                return adt;
                            }

                            let result = getPath(rec, "type.0.text");
                            if (result) {
                                return <b>{result}</b>;
                            }
                            let _class = getEncounterClass(rec);
                            if (_class) {
                                return (
                                    <span className="text-muted">{_class + " encounter"}</span>
                                );
                            }
                            return <small className="text-muted">N/A</small>;
                        }
                    },
                    {
                        label: "Reason",
                        // path: "reason.0.coding.0.display",
                        render: encounter => getEncounterReason(encounter || {}),
                        defaultValue: "N/A"
                    },
                    {
                        label: "Class",
                        render: rec => {
                            let result = getEncounterClass(rec);
                            return result ?
                                <b>{result}</b> :
                                <small className="text-muted">N/A</small>;
                        }
                    },
                    {
                        label: "Status",
                        path: "status",
                        defaultValue: "N/A"
                    },
                    {
                        label: "Time",
                        path: "period",
                        render: o => Period(o.period || {})
                    }
                ]}
            />
        )
    }
}

